module.exports = __webpack_public_path__ + "img/step_3-2.426d26ea.png";